module.exports = __webpack_public_path__ + "static/media/maintence-bg.564ac197.jpg";